
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import LanguageSelector from "@/components/frank/LanguageSelector";
import { useLanguage } from "@/contexts/LanguageContext";

const HomeHeader = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <header className="border-b bg-white/80 backdrop-blur-sm">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <div className="text-2xl font-bold text-[#1A237E] cursor-pointer" onClick={() => navigate('/')}>
          FRANK
        </div>
        <div className="flex items-center gap-4">
          <nav className="hidden md:flex space-x-8">
            <button 
              onClick={() => navigate('/kontakt')}
              className="text-[#2F80ED] hover:text-[#1A237E] transition-colors"
            >
              {t('nav.contact')}
            </button>
            <Button 
              variant="outline" 
              onClick={() => navigate('/auth')}
              className="border-[#1A237E] text-[#1A237E] hover:bg-[#1A237E] hover:text-white"
            >
              {t('nav.login')}
            </Button>
          </nav>
          <LanguageSelector />
        </div>
      </div>
    </header>
  );
};

export default HomeHeader;
